var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1426 9.43136H15.6247V4.43136C15.6247 2.85324 14.3457 1.57422 12.7676 1.57422H7.23186C5.65374 1.57422 4.37472 2.85324 4.37472 4.43136V9.43136H2.85686C2.46177 9.43136 2.14258 9.75056 2.14258 10.1456V18.7171C2.14258 19.1122 2.46177 19.4314 2.85686 19.4314H17.1426C17.5377 19.4314 17.8569 19.1122 17.8569 18.7171V10.1456C17.8569 9.75056 17.5377 9.43136 17.1426 9.43136ZM5.98186 4.43136C5.98186 3.74163 6.54213 3.18136 7.23186 3.18136H12.7676C13.4573 3.18136 14.0176 3.74163 14.0176 4.43136V9.43136H5.98186V4.43136ZM16.2497 17.8242H3.74972V11.0385H16.2497V17.8242ZM9.37472 14.7215V15.9046C9.37472 16.0028 9.45508 16.0831 9.55329 16.0831H10.4462C10.5444 16.0831 10.6247 16.0028 10.6247 15.9046V14.7215C10.809 14.5893 10.9465 14.4019 11.0175 14.1865C11.0885 13.9711 11.0893 13.7387 11.0199 13.5227C10.9504 13.3068 10.8142 13.1185 10.6308 12.9849C10.4475 12.8513 10.2265 12.7794 9.99972 12.7794C9.77289 12.7794 9.55192 12.8513 9.3686 12.9849C9.18528 13.1185 9.04907 13.3068 8.97959 13.5227C8.91011 13.7387 8.91092 13.9711 8.98193 14.1865C9.05294 14.4019 9.19047 14.5893 9.37472 14.7215Z",
    fill: "#3D3D3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.9ba58c239dabf5cbceaf63c50fedb036.svg";
export { ForwardRef as ReactComponent };